import { ChangeDetectionStrategy, Component, input, Input } from '@angular/core';
import { NgClass } from '@angular/common';
import { IconComponent } from '../icon/icon.component';

@Component({
    selector: 'ca-info-box',
    templateUrl: './info-box.component.html',
    styleUrls: ['./info-box.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [NgClass, IconComponent]
})
export class InfoBoxComponent {
    public value = input.required<string>();
    public icon = input<string>();
    public colorVariant = input<'success' | 'error' | 'warning' | 'info'>();
}
